import { Button as Btn } from "antd";
import { DownloadOutlined, EyeOutlined, FileTextOutlined } from "@ant-design/icons";

import { useTranslation } from "contexts/TranslationContext";
import { formatFileSize, openPdf, downloadPdf } from "utilities/pdfDocument";

// Result card for a document-producing service (clearance letter today,
// debt-proof letter later): file name + size, with view and download actions.
// `url` is an object URL from base64ToPdf() — the OWNER of that URL is
// responsible for revoking it, not this component.
const DocumentResultCard = ({ url, fileName, size }) => {
  const { translate } = useTranslation();

  return (
    <div className="bg-white border border-[#E9ECEF] rounded-2xl shadow-sm px-4 py-4 flex items-center gap-4">
      {/* Leading file badge */}
      <span className="w-12 h-12 rounded-xl bg-[#EAF6F7] flex items-center justify-center shrink-0">
        <FileTextOutlined className="text-primary" style={{ fontSize: 22 }} />
      </span>

      {/* Name + meta */}
      <div className="flex-1 min-w-0 text-start">
        <p className="text-[#1F1F1F] text-sm md:text-base font-medium truncate">
          {fileName}
        </p>
        <p className="text-[#8E9196] text-xs md:text-sm">
          {translate("OTHER_SERVICES.PDF_DOCUMENT")}
          {size ? ` - ${formatFileSize(size)}` : ""}
        </p>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-2 shrink-0">
        <Btn
          type="text"
          shape="circle"
          size="large"
          aria-label={translate("OTHER_SERVICES.VIEW")}
          title={translate("OTHER_SERVICES.VIEW")}
          className="bg-[#F5F7F8] text-primary hover:!bg-[#EAF6F7] hover:!text-primary"
          icon={<EyeOutlined />}
          onClick={() => openPdf(url)}
        />
        <Btn
          className="rounded-full bg-primary text-white font-semibold px-6 py-5 border border-primary hover:!border-primary hover:border-solid hover:!text-primary"
          icon={<DownloadOutlined />}
          onClick={() => downloadPdf(url, fileName)}
        >
          {translate("OTHER_SERVICES.DOWNLOAD")}
        </Btn>
      </div>
    </div>
  );
};

export default DocumentResultCard;
